"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type EmptyNotificationsIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useEmptyNotificationsIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/assets/notifications-empty.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/notifications-empty.svg"
    : "/assets/notifications-empty.svg";
}

export function EmptyNotificationsIllustration({
  className,
  alt = "",
  width = 323,
  height = 303,
  ...props
}: EmptyNotificationsIllustrationProps) {
  const src = useEmptyNotificationsIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-auto w-full", className)}
      {...props}
    />
  );
}
